import { Component } from "@angular/core";
import { LanguageService } from './../../Services/languageService';
import { TranslateService } from '@ngx-translate/core';
import { Router } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { userService } from "../../Services/userService";
import { restURL } from "../../Models/restURL";
import { error } from "util";
import { mdlCheckUrlReq } from "../../Models/mdlCheckUrlReq";
import { mdlCheckUrlRes } from "../../Models/mdlCheckUrlRes";
import { mdlUpdatePasswordReq } from "../../Models/mdlUpdatePasswordReq";
import { mdlUpdatePasswordRes } from "../../Models/mdlUpdatePasswordRes";
import Swal from 'sweetalert2';
import * as CryptoJS from 'crypto-js';
import { mdlPayloadRequest } from "../../Models/mdlPayloadRequest";
import { mdlPayloadResponse } from "../../Models/mdlPayloadResponse";
import { motorProposalService } from "../../Services/motorProposalService";







@Component({
    selector: 'PasswordReset',
    templateUrl: './PasswordReset.html',
    styleUrls: ['./PasswordReset.css']
})

export class PasswordReset {

    public isEnglish: boolean;
    public reg: string;
    public iqn: string;
    public dob: string;
    public PasswordsValidate: boolean;
    public isShowLoading: boolean;
    public objmdlCheckUrlReq: mdlCheckUrlReq = new mdlCheckUrlReq();
    public objmdlUpdatePasswordReq: mdlUpdatePasswordReq = new mdlUpdatePasswordReq();
    public objmdlUpdatePasswordRes: mdlUpdatePasswordRes = new mdlUpdatePasswordRes();
    public objmdlCheckUrlRes: mdlCheckUrlRes = new mdlCheckUrlRes();
    public NewPasswordEntered: string;
    public NewPasswordReEntered: string;
    public objPayloadRequest: mdlPayloadRequest = new mdlPayloadRequest();
    public objPayloadResponse: mdlPayloadResponse = new mdlPayloadResponse();

    constructor(private EncriptService: motorProposalService, private router: Router, private http: HttpClient, private lngService: LanguageService, private translate: TranslateService, private userinfo: userService, private Url: restURL) {
        this.PasswordsValidate = false;
        this.isShowLoading = false;
        if (sessionStorage.getItem("Language") != null) {
            $("body").removeClass("Arabic");
            this.translate.setDefaultLang(sessionStorage.getItem("Language"));
            if (sessionStorage.getItem("Language") == 'en') {
                this.translate.currentLang = "en";
                $("body").removeClass("Arabic");
                this.isEnglish = true;
            }
            else if (sessionStorage.getItem("Language") == 'ar') {
                this.translate.currentLang = "ar";
                $("body").addClass("Arabic");
                this.isEnglish = false;
            }

        } else {
            this.translate.setDefaultLang('en');
            this.translate.currentLang = "en";
            sessionStorage.setItem("Language", "en")
            $("body").removeClass("Arabic");
            this.isEnglish = true;
        }
        this.CheckLink()

    }


    CheckLink() {
        let UrlString = this.router.routerState.snapshot.url.split("~");
        let urlPart = UrlString[1];
        let urlRegDetails = urlPart.split(":");

        this.objmdlCheckUrlReq.RegNo = urlRegDetails[0];
        this.objmdlCheckUrlReq.InsuredId = urlRegDetails[1];
        this.objmdlCheckUrlReq.MobileNo = urlRegDetails[2];
        this.objmdlCheckUrlReq.LinkId = urlPart

        if (this.objmdlCheckUrlReq.RegNo.length == 0 || this.objmdlCheckUrlReq.InsuredId.length == 0 || this.objmdlCheckUrlReq.MobileNo.length == 0 || this.objmdlCheckUrlReq.LinkId.length == 0) {
            Swal("Invalid Link", "Invalid Link Please Register", "error")
            return;
        }

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlCheckUrlReq));
        //this.http.post<mdlCheckUrlRes>(this.Url.baseURL + "/Registration/CheckPasswordResetLink", this.objmdlCheckUrlReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        this.http.post<mdlPayloadResponse>(this.Url.baseURL + "/Registration/CheckPasswordResetLink", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
            //this.objmdlCheckUrlRes = result;

            //New Line Start
            this.objPayloadResponse = result;
            this.objmdlCheckUrlRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            //NewLine End

            if (this.objmdlCheckUrlRes.StatusCode != "1") {
                Swal("Invalid Link", this.objmdlCheckUrlRes.ErrorMsg, "error")
                this.router.navigate(['BeforeLogin/NewReg']);
                return;
            }
            if (this.objmdlCheckUrlRes.LinkResult != "1") {
                Swal("Invalid Link", "Invalid Link Please Register", "error")
                this.router.navigate(['BeforeLogin/NewReg']);
            }

        }, (error) => {
            Swal("Error", error, "error")
        });



    }

    CheckPasswords(val) {
        if (this.NewPasswordEntered != val) {
            this.PasswordsValidate = true;

        } else {
            this.PasswordsValidate = false;
        }

    }

    UpdatePassword() {

        if (this.NewPasswordEntered == undefined || this.NewPasswordEntered == null || this.NewPasswordEntered == "") {

            return;
        }
        if (this.NewPasswordEntered != this.NewPasswordReEntered) {
            return;
        }

        this.objmdlUpdatePasswordReq.NewPassword = this.NewPasswordEntered;
        this.objmdlUpdatePasswordReq.RegNo = this.userinfo.EncriptString(this.objmdlCheckUrlReq.RegNo).toString();
        this.objmdlUpdatePasswordReq.NewPassword = this.userinfo.EncriptString(this.objmdlUpdatePasswordReq.NewPassword).toString();


        this.isShowLoading = true;

        this.objPayloadRequest.Payload = this.EncriptService.EncriptPayload(JSON.stringify(this.objmdlUpdatePasswordReq));

        //this.http.post<mdlUpdatePasswordRes>(this.Url.baseURL + "/Registration/UpdatePassword", this.objmdlUpdatePasswordReq, this.userinfo.getHttpOptions()).toPromise().then((result) => {
        this.http.post<mdlPayloadResponse>(this.Url.baseURL + "/Registration/UpdatePassword", this.objPayloadRequest, this.userinfo.getHttpOptions()).toPromise().then((result) => {
            this.isShowLoading = false;

            //New Line Start
            this.objPayloadResponse = result;
            this.objmdlUpdatePasswordRes = JSON.parse(JSON.stringify(this.EncriptService.DecriptPayload(this.objPayloadResponse.PayloadResponse)));
            //NewLine End


            if (this.objmdlUpdatePasswordRes.StatusCode != "1") {
                Swal("Error", this.objmdlUpdatePasswordRes.ErrorMsg, "error")
                this.router.navigate(['BeforeLogin/NewReg']);
            }
            else {
                Swal("Info", "Password Updated Successfully", "info")
                this.router.navigate(['BeforeLogin/Login']);
            }

        }, (error) => {
            this.isShowLoading = false;
            Swal("Error", error, "error")
            this.router.navigate(['BeforeLogin/NewReg']);
        });
    }





    CancelReset() {
        this.router.navigate(['BeforeLogin/NewReg']);
    }


    changeLanguage(langauge) {
        if (langauge == "en") {
            this.isEnglish = true;
            sessionStorage.setItem("Language", "en");
            $("body").removeClass("Arabic");
        }
        else if (langauge == "ar") {
            this.isEnglish = false;
            $("body").addClass("Arabic");
            sessionStorage.setItem("Language", "ar");
        }
        this.translate.use(langauge);
        this.lngService.setLng(langauge)
    }



}


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/PasswordReset/PasswordReset.ts